import React from 'react';
import { LcaCustomResultModel, Option } from 'types/types';

import { PdfPage } from './Styles.styled';
import LCACustomResultSection from './LCACustomResultSection';

const LCACustomResultsPage: React.FunctionComponent<{
  lcaCustomResults: LcaCustomResultModel[];
  additionalPerformanceResultsTypeLookup: Option[];
  scenariosLookup: Option[];
}> = ({ lcaCustomResults, additionalPerformanceResultsTypeLookup, scenariosLookup }) => {
  return (
    <PdfPage className="landscape">
      {lcaCustomResults?.map((customResult: LcaCustomResultModel) => (
        <LCACustomResultSection
          key={customResult.id}
          customResult={customResult}
          additionalPerformanceResultsTypeLookup={additionalPerformanceResultsTypeLookup}
          scenariosLookup={scenariosLookup}
        />
      ))}
    </PdfPage>
  );
};

export default LCACustomResultsPage;
